import React, { useEffect } from "react";
import { connect } from "react-redux";
const getYoutubeData = async (youtubeUrl) => {
  const url = `https://www.youtube.com/oembed?url=${youtubeUrl}&format=json`;
  const data = (await fetch(url));
  return data.json();
};

const getYoutubeUrl = (content) => {
  const pattern = /youtube\.com\/embed\/([\w-]+)/g;
  const [_, youtubeId] = pattern.exec(content) || [];
  if (!youtubeId) {
    return "";
  }
  return `https://www.youtube.com/watch?v=${youtubeId}`;
};

const ButtonGetYoutubeData = ({ content, handleUpdatePostData, post }) => {
  const fetchYoutubeData = async () => {
    const { currentPost: { content: contentPost }} = post || {};
    const youtubeUrl = getYoutubeUrl(contentPost);
    if (youtubeUrl) {
      const data = await getYoutubeData(youtubeUrl);
      handleUpdatePostData({
        title: data.title,
        thumbnail_url: data.thumbnail_url
      });
    }
  }
  return <button className="btn-primary" onClick={fetchYoutubeData}>Lấy thông tin</button>;
};

export default connect(
  store => {
    return {
      post: store.post,
      config: store.config
    };
  },
  dispatch => {
    return {
      setCurrentPost: value => {
        dispatch(postActions.setCurrentPost(value));
      },
      changeFieldValue: (field, value) => { dispatch(change('formPostEdit', field, value)) },
    };
  }
)(ButtonGetYoutubeData);
